import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { setupIonicReact } from "@ionic/react";
import { setOptions as setMobiscrollOptions } from "@mobiscroll/react";
import { applyDefaultTheme } from "@pymblecitizencoders/cc-ui/theme";
/* CSS ORDER MATTERS — later wins on equal specificity.
   Base resets and third-party frameworks first, then cc-ui (the design system
   must win for buttons/inputs), then our own overrides. Do not reorder these.

   Bootstrap is gone: every control is a cc-ui component, and its grid — the
   last thing left — is now .em-grid in eventManager.css. That also retires the
   hazard this comment used to warn about, where Bootstrap's Reboot could beat
   cc-ui's components if the two were loaded the wrong way round. */
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@mobiscroll/react/dist/css/mobiscroll.min.css";
// pymble-ui is retained for theme.css: the @font-face rules for the
// Canela/Museo Sans/GT Pressura brand faces, plus --ion-font-family. styles.css
// was dropped when the editor moved to cc-ui — it held nothing but
// .pymble-editor__* and .tiptap rules for TextEditor — and components.css is
// not needed either.
//
// NOTE: nothing sets Canela any more. .em-page-title was the only rule that
// did, and it went with the "Event Manager" heading in the filter rail. This
// import now earns its place only through --ion-font-family; if that stops
// being true it can go, along with the `html { font-weight: 100 }` this file
// has to override in index.css.
import "pymble-ui/theme.css";
import "@pymblecitizencoders/cc-ui/index.css";
import "@pymblecitizencoders/cc-ui/auth.css";
import "@pymblecitizencoders/cc-ui/editor.css";
import "./index.css";
import App from "./App";
import { configureLottieWasm } from "./utils/lottieWasm";
import { msal as msalConfig } from "./config";

setupIonicReact();
applyDefaultTheme();

/* Before anything renders: the Lottie player reads this when it first starts a
   frame, and the default sends it to a public CDN. */
configureLottieWasm();

/* Mobiscroll defaults themeVariant to "auto", which follows the OS colour
   scheme — the calendar would render dark for anyone on a dark-mode machine
   while the rest of the app stayed light. Pin it light, globally rather than
   per-component so it also covers the SegmentedGroup view switcher, which sits
   outside the Eventcalendar. (v2 sets the same values on its Eventcalendar.) */
setMobiscrollOptions({ theme: "auto", themeVariant: "light" });

export const msalInstance = new PublicClientApplication(msalConfig);

// MSAL v4: initialize() must complete before any MSAL API call.
msalInstance.initialize().then(() => {
	const root = ReactDOM.createRoot(
		document.getElementById("root") as HTMLElement,
	);
	root.render(<App msalInstance={msalInstance} />);
});
